// WARNING!
// This module is generated automatically.
// All the manual changes will be overwritten.

import { css } from 'styled-components';

export const swiperEffectCardsCSS = css`
  .swiper-cards {
    overflow: visible;
  }
  .swiper-cards .swiper-slide {
    transform-origin: center bottom;
    backface-visibility: hidden;
  }
`;
